var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdjust(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.05288 1.08789C1.88967 1.08789 1.73315 1.14408 1.61774 1.2441C1.50233 1.34412 1.4375 1.47978 1.4375 1.62122C1.4375 1.76267 1.50233 1.89833 1.61774 1.99835C1.73315 2.09837 1.88967 2.15456 2.05288 2.15456H16.8221C16.9853 2.15456 17.1419 2.09837 17.2573 1.99835C17.3727 1.89833 17.4375 1.76267 17.4375 1.62122C17.4375 1.47978 17.3727 1.34412 17.2573 1.2441C17.1419 1.14408 16.9853 1.08789 16.8221 1.08789H2.05288ZM1.4375 5.88789C1.4375 5.74644 1.50233 5.61079 1.61774 5.51077C1.73315 5.41075 1.88967 5.35456 2.05288 5.35456H16.8221C16.9853 5.35456 17.1419 5.41075 17.2573 5.51077C17.3727 5.61079 17.4375 5.74644 17.4375 5.88789C17.4375 6.02934 17.3727 6.16499 17.2573 6.26501C17.1419 6.36503 16.9853 6.42122 16.8221 6.42122H2.05288C1.88967 6.42122 1.73315 6.36503 1.61774 6.26501C1.50233 6.16499 1.4375 6.02934 1.4375 5.88789ZM1.4375 10.1546C1.4375 10.0131 1.50233 9.87745 1.61774 9.77743C1.73315 9.67741 1.88967 9.62122 2.05288 9.62122H9.4375H16.8221C16.9853 9.62122 17.1419 9.67741 17.2573 9.77743C17.3727 9.87745 17.4375 10.0131 17.4375 10.1546C17.4375 10.296 17.3727 10.4317 17.2573 10.5317C17.1419 10.6317 16.9853 10.6879 16.8221 10.6879H2.05288C1.88967 10.6879 1.73315 10.6317 1.61774 10.5317C1.50233 10.4317 1.4375 10.296 1.4375 10.1546Z",
    fill: "#9F9C9C",
    stroke: "#1634A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdjust);
export default __webpack_public_path__ + "static/media/adjust.f33a3a8af9a7efe83198a2fa831503eb.svg";
export { ForwardRef as ReactComponent };